import React from 'react';
import Banner from '../Components/Banner';
import ContactForm from '../ContactForm/ContactFrom';
import { serviceCatalog } from '../data/serviceCatalog';
import { useLanguage } from '../context/LanguageContext';

function ServiceDetail({ match }) {
  const { t, lang } = useLanguage();
  const service = serviceCatalog.find((item) => item.slug === match.params.slug);

  if (!service) {
    return (
      <div className="page-wrap">
        <Banner pageName={t.pages.services} pageLink="/services" subtitle={t.services.subtitle} />
        <section className="section">
          <div className="container section-title center">
            <h2>Service not found</h2>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="page-wrap">
      <Banner pageName={service.title[lang]} pageLink={`/services/${service.slug}`} subtitle={service.heroTitle[lang]} />

      <section className="section">
        <div className="container split-panel">
          <div className="visual-block" style={{ backgroundImage: `url(${service.image})` }}>
            <div className="visual-overlay">
              <div className="eyebrow">Innovative Horizons</div>
              <h2>{service.heroTitle[lang]}</h2>
              <p>{service.heroText[lang]}</p>
            </div>
          </div>
          <div>
            <div className="section-title">
              <div className="eyebrow">Service detail</div>
              <h2>{service.title[lang]}</h2>
              <p>{service.desc[lang]}</p>
            </div>
            <div className="info-card">
              <h3>{t.services.detailTitle}</h3>
              <ul className="check-list">
                {service.bullets[lang].map((item) => <li key={item}>{item}</li>)}
              </ul>
              <h3>{t.services.deliverablesTitle}</h3>
              <ul className="check-list">
                {t.services.deliverables.map((item) => <li key={item}>{item}</li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <ContactForm service={service} />
    </div>
  );
}

export default ServiceDetail;
